import BigNumber from 'bignumber.js';

export function formatAddress(address) {
  if (typeof address !== 'string') return '-';
  return address.slice(0, 6) + '...' + address.slice(-4);
}

export function formatNumber(number, fix = 2) {
  if (isNaN(number)) return 0;
  return new BigNumber(number).dividedBy(1e18).toFixed(fix);
}
